import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../../state/helpers/IntlProps"
import {
    ECOMMERCE_RULE_KEY,
    ECOMMERCE_RULE_KEYS,
} from "../../../state/ecommerce-configuration/EcommerceRule"
import {
    RULE_KEY_SELECT_MESSAGES,
} from "../../../state/ecommerce-configuration/messages/EcommerceRuleMessages"

type Props = {
    intl: Intl,
    onUpdate: (ruleKey: string) => void,
    disabled: boolean,
    selectedRuleKey?: ECOMMERCE_RULE_KEY,
}

const EcommerceRuleKeySelect = (props: Props) => {
    const RULE_KEY_OPTIONS = ECOMMERCE_RULE_KEYS.map(ruleKey => {
        return {
            label: props.intl.formatMessage(RULE_KEY_SELECT_MESSAGES[ruleKey] ?
                RULE_KEY_SELECT_MESSAGES[ruleKey] : RULE_KEY_SELECT_MESSAGES.select),
            value: ruleKey,
        }
    })

    const [selectedRuleKeyOption, setSelectedRuleKeyOption] = useState(props.selectedRuleKey ? {
        label: props.intl.formatMessage(RULE_KEY_SELECT_MESSAGES[props.selectedRuleKey] ?
            RULE_KEY_SELECT_MESSAGES[props.selectedRuleKey] : RULE_KEY_SELECT_MESSAGES.select),
        value: props.selectedRuleKey,
    } : RULE_KEY_OPTIONS[0])

    return (
        <Select
            className="rule-key"
            placeholder={props.intl.formatMessage(RULE_KEY_SELECT_MESSAGES.select)}
            value={selectedRuleKeyOption}
            onChange={(selectedOption) => {
                setSelectedRuleKeyOption(selectedOption)
                props.onUpdate(selectedOption.value)
            }}
            options={RULE_KEY_OPTIONS}
            clearable={false}
            searchable={false}
            disabled={props.disabled}
            multi={false}
        />
    )
}

export default injectIntl(EcommerceRuleKeySelect)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceRuleKeySelect.tsx